"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hmo$ = exports.Hmo$outboundSchema = exports.Hmo$inboundSchema = void 0;
exports.hmoToJSON = hmoToJSON;
exports.hmoFromJSON = hmoFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const hmorecord_js_1 = require("./hmorecord.js");
/** @internal */
exports.Hmo$inboundSchema = z
    .object({
    has_hmo: z.boolean(),
    records: z.array(hmorecord_js_1.HmoRecord$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "has_hmo": "hasHmo",
    });
});
/** @internal */
exports.Hmo$outboundSchema = z
    .object({
    hasHmo: z.boolean(),
    records: z.array(hmorecord_js_1.HmoRecord$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        hasHmo: "has_hmo",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Hmo$;
(function (Hmo$) {
    /** @deprecated use `Hmo$inboundSchema` instead. */
    Hmo$.inboundSchema = exports.Hmo$inboundSchema;
    /** @deprecated use `Hmo$outboundSchema` instead. */
    Hmo$.outboundSchema = exports.Hmo$outboundSchema;
})(Hmo$ || (exports.Hmo$ = Hmo$ = {}));
function hmoToJSON(hmo) {
    return JSON.stringify(exports.Hmo$outboundSchema.parse(hmo));
}
function hmoFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Hmo$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Hmo' from JSON`);
}
//# sourceMappingURL=hmo.js.map